<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row class="m-3">
                <b-col>
                    <div>
                        <p class="font-weight-bold">D. SCHOLARSHIPS/TUITION ASSISTANCE/AWARDS.</p>
                    </div>
                    <b-table-simple
                        responsive
                        striped
                        hover
                        class="text-sm text-md-md"
                    >
                        <b-thead>
                            <b-tr>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr
                                v-for="(menu, j) in data"
                                :key="j"
                                class="py-2 py-md-3"
                            >
                                <b-td class="font-weight-bold">{{ menu.key }}</b-td>
                                <b-td>
                                    <span v-html="menu.value"></span>
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                    <div>
                        <!-- Mentora ESL: 80% attendance, ESL terminolojisi -->
                        <p v-if="isMentoraProgram">*Students who earn a scholarship/tuition discount/award of any category should meet the following criteria to maintain the award:
                            <br>
                            1) Continuously enroll in courses each module, and
                            <br>
                            2) Maintain a minimum attendance rate of 80% for any Module, and
                            <br>
                            3) Avoid any probation or disciplinary action for any reason.<br>
                            Scholarships, tuition discounts and/or awards are available for students who qualify. That is why continuing your studies at BAU in the Mentora ESL Program is essential, as another student might have been rejected at the time of your application.
                            Therefore, if a student who was awarded any scholarship or tuition assistance withdraws from the Mentora ESL Program and does not transfer into the BAU degree program, they will not receive a refund of the deposit, and/or may be required to repay the award or pay an Administrative Service Fee. BAU Mentora ESL Program is committed to re-use these funds for students who need or earn financial assistance.
                        </p>
                        <!-- Diğer programlar: CGPA, processing fee -->
                        <p v-else>*Students who earn a scholarship or tuition assistance of any category should meet the following criteria to maintain the scholarship:
                            <br>
                            1)	Continuously enroll in courses to meet graduation requirements (unless taking an approved Leave of Absence) and
                            <br>
                            2)	Maintain a minimum Cumulative Grade Point Average (CGPA) of 2.0 at Undergraduate and 3.0 at Graduate level for any semester and
                            <br>
                            3)	Avoid any disciplinary action for any reason.<br>
                            Scholarships and tuition assistance are available using the university's funds allocated for students who need additional financial aid. That is why continuing your studies at BAU is essential, as another student might have been rejected at the time of your application. Therefore, if a student who was awarded any scholarship or tuition assistance withdraws from BAU for any reason, they are required to pay the award amount back for all course credits they have completed since the scholarship or tuition assistance was awarded to them. BAU is committed to re-use these funds for students who need financial aid. If the student wishes to transfer their SEVIS record to another institution prior to or during the semester, BAU will not refund any portion of their tuition or fees. <strong>Additionally, the student will be required to pay a processing fee of $ 2,000.</strong>
                        </p>
                    </div>
                </b-col>

                <b-col cols="12" class="mt-3">
                    <b-row class="d-flex align-items-center flex-column flex-md-row  justify-content-md-between">
                        <b-col cols="12" md="8" class="mb-2 mb-md-0 d-flex flex-row-md-reverse flex-row">
                            <ValidationProvider
                                name="status"
                                rules="required"
                                v-slot="{ valid, errors }"
                            >
                                <div class="d-flex flex-row-reverse">
                                    <b-form-checkbox
                                        id="checkbox-1"
                                        v-model="form.status"
                                        name="checkbox-1"
                                        value="accepted"
                                        :unchecked-value="null"
                                        class="text-sm text-md-md ml-4"
                                    >
                                    </b-form-checkbox
                                    >
                                    <div>
                                        {{ $t('confirm_information_accuracy') }}
                                    </div>
                                </div>
                                <b-form-invalid-feedback v-if="errors[0]">
                                    {{ errors[0] }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="4" class="text-md-right mt-3">
                            <b-button
                                type="submit"
                                @click="next"
                                variant="primary"
                                class="w-100 w-md-auto"
                            >
                                {{ $t('next') }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </ValidationObserver>


    </div>
</template>
<script>

import {mapGetters} from "vuex";

export default {
    props:{
        studentInformation: {
            type: Object,
        }
    },
    data() {
        return {
            data: [],
            form: {},
        }
    },
    computed: {
        ...mapGetters({
            formData: "enrollmentAgreementForm/formData"
        }),
        isMentoraProgram() {
            return this.formData?.program_code === '0702002'
        }
    },
    methods: {
        async next(){
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid){
                this.$emit('next',1)
            }
        },
        async getData() {
            window.scrollTo(0,0)
            // Mentora ESL: Module terminolojisi | Diğer: Semester/Admission terminolojisi
            if (this.isMentoraProgram) {
                this.data.push(
                    {
                        key: 'Type of Scholarship/Discount/Award Applied During Module',
                        value: this.studentInformation.scholarship_name,
                    },
                    {
                        key: 'Start Date of Module to Which Scholarship/Discount/Award Applied',
                        value: `$${this.studentInformation.total_discount_amount ?? 0} (Write "0" if the student does not have any)`,
                    },
                    {
                        key: 'Amount That Will Be Applied This Module',
                        value: `$${this.studentInformation.discount_amount ?? 0}`,
                    },
                    {
                        key: 'OTHER',
                        value: `$${this.studentInformation.total_discount_amount ?? 0}`,
                    },
                    {
                        key: 'Additional Awards Given for This Module',
                        value: `$${this.studentInformation.additional_awards_amount ?? 0} (Write "0" if the student does not have any)`,
                    },
                )
            } else {
                this.data.push(
                    {
                        key: 'Type of the Scholarship or Tuition Assistance Awarded During Admission',
                        value: this.studentInformation.scholarship_name,
                    },
                    {
                        key: 'Amount of the Scholarship or Tuition Assistance Awarded for the Duration of the Program of Study*',
                        value: this.currencyFormat(this.studentInformation.total_discount_amount??0),
                    },
                    {
                        key: 'Per Credit Amount That Will be Applied This Semester',
                        value: this.currencyFormat(this.studentInformation.discount_amount??0),
                    },
                    {
                        key: 'OTHER',
                        value: 'Repeat credits and additional credits are exempt of the use of such scholarship/tuition assistance credits.',
                    },
                    {
                        key: 'Additional Awards Given for This Semester',
                        value: this.currencyFormat(this.studentInformation.additional_awards_amount??0),
                    },
                )
            }
        },
        back(){
            this.$emit('back', -1);
        }
    },
    created() {
        this.getData()
    },
}
</script>
